import { ThunkType } from 'app/hooks/appHooks';
import { resetAllProducts, setRelationProducts } from 'app/store/reducers/product';
import {
  currentProductTypesSelector,
  currentProductTypesExtendedSelector,
} from 'app/store/selectors';

export const updateProducts = (): ThunkType<void> => (dispatch, getState) => {
  const state = getState();

  const currentProductTypes = currentProductTypesSelector(state);
  const currentProductTypesExtended = currentProductTypesExtendedSelector(state);
  dispatch(resetAllProducts());
  dispatch(
    setRelationProducts({
      relationProducts: { ...currentProductTypes, ...currentProductTypesExtended },
    }),
  );
};
